import { CloseRounded } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, type Theme, Typography, styled } from "@mui/material";

interface PropertyPhotoProps {
  theme?: Theme;
  $photo: string;
}
interface ContactInfoProps {
  theme?: Theme;
  $hasLink: boolean;
}

export const ModalDialog = styled(Dialog)(({ theme }: { theme: Theme }) => ({
  "& .MuiDialogContent-root": {
    paddingTop: "16px !important",
    [theme.breakpoints.between("xs", "sm")]: {
      overflowY: "unset",
    },
  },
  "& > div > .MuiPaper-root": {
    backgroundColor: "rgba(70,70,70) !important",
    padding: "16px",
    width: "auto",
    borderRadius: "20px",
    gap: "16px",
    [theme.breakpoints.between("xs", "sm")]: {
      width: "100%",
      margin: 0,
      gap: 0,
      padding: 0,
      paddingTop: "40px",
      backgroundColor: "#000 !important",
      borderRadius: 0,
      maxHeight: "100%",
    },
  },
}));

export const ModalTitle = styled(DialogTitle)({
  color: "#fff",
  fontSize: "24px",
  fontWeight: "700",
  backgroundColor: "#000",
  display: "flex",
  flexDirection: "row",
  gap: "16px",
});

export const ModalHeader = styled("div")({
  width: "100%",
});

export const Title = styled("div")({
  display: "flex",
  justifyContent: "space-between",
});

export const PropertyLogo = styled("img")(({ theme }: { theme: Theme }) => ({
  height: "64px",
  width: "auto",
  [theme.breakpoints.between("xs", "sm")]: {
    display: "none",
  },
}));

export const PropertyName = styled(Typography)({
  fontSize: "24px",
  fontWeight: "700",
});

export const CloseIcon = styled(CloseRounded)(({ theme }: { theme: Theme }) => ({
  backgroundColor: theme.palette.semanticSurface.dark,
  width: "32px",
  height: "32px",
  padding: "4px",
  color: "#A2A2A2",
  borderRadius: "24px",
  alignSelf: "center",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: theme.palette.semanticNeutral.main,
  },
}));

export const Divider = styled("div")({
  height: "8px",
});

export const PropertyAddress = styled("div")({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "24px",
  opacity: "0.8",
});

export const ModalContent = styled(DialogContent)({
  height: "100%",
  backgroundColor: "#000",
});

export const PropertyDescription = styled(Typography)(({ theme }: { theme: Theme }) => ({
  color: theme.palette.semanticNeutral.dark,
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "24px",
  maxHeight: "72px",
  overflowY: "scroll",
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.semanticNeutral.dark,
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: theme.palette.semanticNeutral.light,
  },
  [theme.breakpoints.between("xs", "sm")]: {
    fontSize: "14px",
    maxHeight: "unset",
    paddingBottom: "16px",
    "&::-webkit-scrollbar": {
      width: "0px",
    },
  },
}));

export const PropertyDetailsWrapper = styled("div")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  gap: "16px",
  marginTop: "16px",
  [theme.breakpoints.between("xs", "sm")]: {
    flexDirection: "column",
  },
}));

export const PropertyPhoto = styled("img")(({ theme = {} as Theme, $photo }: PropertyPhotoProps) => ({
  height: "320px",
  aspectRatio: "4 / 3",
  display: $photo ? "block" : "none",
  [theme.breakpoints.between("xs", "sm")]: {
    height: "100%",
    marginBottom: "16px",
  },
}));

export const PropertyMap = styled("div")(({ theme = {} as Theme, $photo }: PropertyPhotoProps) => ({
  height: "320px",
  aspectRatio: "4 / 3",
  backgroundSize: "cover",
  backgroundImage: `url(${$photo})`,
  backgroundPosition: "center",
  overflow: "hidden",
  display: $photo ? "block" : "none",
  [theme.breakpoints.between("xs", "sm")]: {
    height: "100%",
    marginBottom: "16px",
  },
}));

export const BrandingLists = styled("div")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  gap: "16px",
  [theme.breakpoints.between("xs", "sm")]: {
    justifyContent: "stretch",
    gap: "0px",
  },
}));

export const ListColumn = styled("div")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  [theme.breakpoints.between("xs", "sm")]: {
    width: "100%",
  },
}));

export const CommonWrapper = styled("div")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  [theme.breakpoints.between("xs", "sm")]: {
    gap: "16px",
  },
}));

export const ContactInfo = styled("a")(({ theme = {} as Theme, $hasLink }: ContactInfoProps) => ({
  color: "#fff",
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "20px",
  textAlign: "center",
  width: "100%",
  userSelect: "text",
  textDecoration: "underline",
  display: $hasLink ? "block" : "none",
  [theme.breakpoints.between("xs", "sm")]: {
    fontWeight: "500",
    textDecoration: "none",
    color: "#A2A2A2",
    backgroundColor: theme.palette.semanticSurface.dark,
    padding: "8px 16px",
    borderRadius: "24px",
  },
}));
